import {createSlice, PayloadAction} from "@reduxjs/toolkit";

import {IInitialStateScientificTitle,  IScientificTitlePayload} from "../types";

import {GetScientificTitles} from "./thunk";


const initialState: IInitialStateScientificTitle = {
    scientificTitleData: [],
    selectedScientificTitleIDs:[],
    isLoadingScientificTitle: false,
    scientificTitleRestoreData:[],
    isViewScientificTitleRestore:false,
};

const scientificTitleSlice = createSlice({
    name: "scientificTitle",
    initialState,
    reducers: {
        setScientificTitle: (state, action:PayloadAction<{data:IScientificTitlePayload[]}> ) => {
            const {data}  =action.payload
           state.scientificTitleData = data

        },


        deletedScientificTitle: (state, action: PayloadAction<number>) => {
            state.scientificTitleData  = state.scientificTitleData.filter(
                (elem) => elem.id !== action.payload
            );

        },
        updateScientificTitle: (state, action: PayloadAction<IScientificTitlePayload>) => {
            const updateData = action.payload;

            state.scientificTitleData = state.scientificTitleData.map((elem) => {
                if (elem.id === updateData.id) {
                    return {
                        ...elem,
                        ...updateData,
                    };
                }
                return elem;
            });
        },
        setIsViewScientificTitleRestore:(state)=>{

            state.isViewScientificTitleRestore =!state.isViewScientificTitleRestore;
        },

        setScientificTitleRestoreData:(state, action) => {
            state.scientificTitleRestoreData = action.payload;
        },
        deletedRestoreScientificTitle:(state,action)=>{
            state.scientificTitleRestoreData  = state.scientificTitleRestoreData.filter(
                (elem) => elem.id !== action.payload
            );
        },
        setSelectedScientificTitleIDs: (state, action) => {
            state.selectedScientificTitleIDs=action.payload
        },


    },
    extraReducers: (builder) => {
        builder
            .addCase(GetScientificTitles.pending, (state) => {
                state.isLoadingScientificTitle = true;
            })
            .addCase(GetScientificTitles.fulfilled, (state) => {
                state.isLoadingScientificTitle = false;
            })
            .addCase(GetScientificTitles.rejected, (state) => {
                state.isLoadingScientificTitle = false;
            });
    },
});

export const {
    setScientificTitle,
    deletedScientificTitle,
    updateScientificTitle,
    setIsViewScientificTitleRestore,
    setScientificTitleRestoreData,
    deletedRestoreScientificTitle,
    setSelectedScientificTitleIDs,
} =
    scientificTitleSlice.actions;

export default scientificTitleSlice;
